<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="label">证件挂失补办</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')"></i>
      </div>
      <div class="desc">因承租人原因导致需要补办证件时，承租人需支付相关费用。</div>
    </div>
    <div class="ai-box" v-if="tip">
      <span class="ai-tag">AI</span>
      <span class="ai-text">{{ tip }}</span>
    </div>
    <div class="rule-body">
      <div class="doc-row" v-for="item in docItems" :key="item.key">
        <el-checkbox
          :value="licenceChecked[item.key]"
          @change="updateChecked(item.key, $event)"
        >
          {{ item.label }}
        </el-checkbox>
        <el-form-item
          :prop="`${propPrefix}.licence.${item.key}`"
          :rules="licenceChecked[item.key] ? getRules(10000) : []"
          class="flex-input single"
          style="margin-left: 20px; margin-bottom: 0;">
          <el-input
            :value="licence[item.key]"
            placeholder="请输入"
            size="small"
            :disabled="!licenceChecked[item.key]"
            v-number:float
            @input="updateLicence(item.key, $event)"
          >
            <template slot="append">元/次</template>
          </el-input>
        </el-form-item>
      </div>
      <el-form-item
        class="hidden-form-item"
        :prop="`${propPrefix}.licenceChecked`"
        :rules="[{ required: true, validator: validateChecked, trigger: 'change' }]"
        style="margin-bottom: 0px;"
      >
      </el-form-item>
    </div>
  </div>
</template>

<script setup>
import { inject, nextTick } from 'vue'
import { getRules } from './utils'

const elForm = inject('elForm', {})

const props = defineProps({
  licence: {
    type: Object,
    required: true,
  },
  licenceChecked: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String, // e.g., "rentCarRule"
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:licence', 'update:licenceChecked', 'remove'])

const docItems = [
  { key: 'drivingLicenseReissueFee', label: '行驶证' },
  { key: 'vehicleRegistrationReissueFee', label: '车辆运营证' },
  { key: 'vehicleKeyReissueFee', label: '车钥匙' },
  { key: 'vehiclePlateReissueFee', label: '车牌' },
]

const updateLicence = (key, value) => {
  const newItem = { ...props.licence, [key]: value }
  emit('update:licence', newItem)
  nextTick(() => {
    elForm.validateField(`${props.propPrefix}.licence.${key}`)
  })
}

const updateChecked = (key, value) => {
  const newItem = { ...props.licenceChecked, [key]: value }
  emit('update:licenceChecked', newItem)
  if (!value) {
    updateLicence(key, '')
  }
  nextTick(() => {
    elForm.validateField(`${props.propPrefix}.licenceChecked`)
  })
}

const validateChecked = (rule, value, callback) => {
  const hasChecked = Object.values(props.licenceChecked).some((item) => item === true)
  if (!hasChecked) {
    callback(new Error('请至少选择并填写一项证件补办费用'))
  } else {
    callback()
  }
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
